<div class="widget-inner-title">HTTP Auth Type:
  <i class="fa fa-info-circle info-text"></i>
</div>
<div class="widget-inner-content">
  <div class="input-edit-row">
    <input #inputCheck
           class="server-name"
           value="{{inputAuthType}}"
           [disabled]="inputIsDisable"/>

    <div class="select-edit-btn-area input-edit-btn-area">
      <i *ngIf="isAdmin"
         class="fa fa-edit transition text-tooltip"
         aria-hidden="true"
         title-popup="Edit"
         (click)="inputOnClick()"
         [hidden]="inputIsHidden"></i>

      <button class="transition text-tooltip tooltip-edit"
              [hidden]="!inputIsHidden"
              (click)="inputOnSave()"
              [disabled]="hasError"
              title-popup="Save">
        <i class="fa fa-check"
           [ngClass]="{'disabled':hasError}"
           aria-hidden="true"></i>
      </button>

      <button class="transition text-tooltip tooltip-edit"
              title-popup="Cancel"
              [hidden]="!inputIsHidden"
              (click)="inputOnCancel(inputCheck)">
        <i class="fa fa-times"
           aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="modify-live-search" [hidden]="!inputIsHidden">
    <div class="info-content">
      <div class="widget-inner-title">AuthType:
        <i class="fa fa-info-circle info-text"></i>
      </div>
      <div class="widget-inner-content">
        <ngx-select [allowClear]="true"
                   [items]="allAuthTypes"
                   (select)="selectedAuthType($event)">
        </ngx-select>
      </div>
    </div>
    <ng-container *ngIf="!authDetailsHidden()">
      <div class="info-content">
        <div class="widget-inner-title">Auth Username:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input #inputCheckUsername
                 [ngClass]="{'ng-invalid': hasError }"
                 value="{{inputAuthUsername}}"
                 class="server-name"
                 [hidden]="authDetailsHidden()"
                 (input)="testValidation('authUsername',inputCheckUsername.value, inputCheckUsername, $event)"
                 (change)="testValidation('authUsername',inputCheckUsername.value, inputCheckUsername, $event)"
                 (keydown)="testValidation('authUsername',inputCheckUsername.value, inputCheckUsername, $event)"
                 (keyup)="testValidation('authUsername',inputCheckUsername.value, inputCheckUsername, $event);trimValue($event)"
                 autocomplete="off"/>
          <div class="alert alert-danger alert-validate error-validate"
               *ngIf="hasError">{{errorMessageAuthUsername}}
          </div>
        </div>
      </div>
      <div class="info-content">
        <div class="widget-inner-title">Auth Password:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input #inputCheckPassword
                 [ngClass]="{'ng-invalid': hasError }"
                 value="{{inputAuthPassword}}"
                 class="server-name"
                 validationType="authPassword"
                 [hidden]="authDetailsHidden()"
                 (input)="testValidation('authPassword',inputCheckPassword.value, inputCheckPassword, $event)"
                 (change)="testValidation('authPassword',inputCheckPassword.value, inputCheckPassword, $event)"
                 (keydown)="testValidation('authPassword',inputCheckPassword.value, inputCheckPassword, $event)"
                 (keyup)="testValidation('authPassword',inputCheckPassword.value, inputCheckPassword, $event);trimValue($event)"/>
          <div class="alert alert-danger alert-validate error-validate"
               *ngIf="hasError">{{errorMessageAuthPassword}}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="alert alert-danger alert-validate error-validate"
     *ngIf="hasError">{{errorMessage}}
</div>
